import React from 'react';

export default function DeliveriesTab() {
	return <div style={{ minHeight: '200px', padding: '2em' }}>Deliveries</div>;
}
